import { get } from '@eika-infrastruktur/request';

import { Samtykkeoppdrag } from '../generated-types';
import { CONTEXT_PATH } from './index';

export const SERVICE_PATH = `/rest/resource/samtykke`;

export const getConsentAssignments = async () => get<Samtykkeoppdrag[]>(`${CONTEXT_PATH}${SERVICE_PATH}`);
